import React from 'react';

const MetricContext = React.createContext({});

export default MetricContext;
